// utils.js
export function setCookie(name, value, hours) {
  const expires = new Date(Date.now() + hours * 3600_000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; SameSite=Strict`;
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export function eraseCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
}
